export default "__VITE_ASSET___MS2TQRy__"